import React from 'react';
import CustomSelect from '../../../components/forms/CustomSelect';
import CustomTextDelayInput from '../../../components/forms/CustomTextDelayInput';
import DateField from '../../../components/forms/DateField';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';
import { useFiltersPR } from '../../../components/providers/FiltersProvider';
import { vehicleStatusesSpanish } from '../../../utils/SelectorMapping';
import useCompanies from '../../../hooks/api-calls/useCompanies';

const VehicleFilters: React.FC = () => {
    const { filters, updateFilters } = useFiltersPR();
    const { userCan } = usePrivilege();
    const { getCompaniesList  } = useCompanies();

    return (
        <>
            <CustomTextDelayInput
                id="plateNumber"
                label="Matrícula"
                placeholder="Buscar por matrícula..."
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomTextDelayInput
                id="brand"
                label="Marca"
                placeholder="Buscar por marca..."
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomTextDelayInput
                id="model"
                label="Modelo"
                placeholder="Buscar por modelo..."
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomSelect
                id="status"
                label="Estado"
                placeholder="Seleccionar estado"
                options={vehicleStatusesSpanish}
                value={vehicleStatusesSpanish.filter((item: any) => filters.filter_filters?.status?.includes(item.value))}
                onChange={(value: any) => updateFilters({ status: value.map((item: any) => item.value) })}
                isClearable={true}
                isMulti={true}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de Creación"
                placeholderText="Selecciona las fechas"
                selectedDateField={filters.filter_filters?.between_dates?.type || "createdAt"}
                dateTypesOptions={[
                    { label: "Fecha de creación", value: "createdAt" },
                    { label: "Fecha de modificación", value: "updatedAt" },
                    { label: "Fecha de venta", value: "saleDate" },
                    { label: "Fecha de compra", value: "purchaseDate" },
                ]}
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;
                    if (between_dates && filters_between_dates !== between_dates) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1], type: date[2] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />

            {userCan('list', 'company') && (
                <CustomSelect
                    id="company"
                    label="Compañía"
                    placeholder="Seleccionar compañía"
                    options={getCompaniesList()}
                    value={filters.filter_filters?.company ? { value: filters.filter_filters?.company, label: getCompaniesList()?.find((g: any) => g.value === filters.filter_filters?.company)?.label } : null}
                    onChange={(value: any) => updateFilters({ company: value?.value })}
                    isClearable={true}
                    isSearchable={true}
                />
            )}
        </>
    );
};

export default VehicleFilters;